import React from 'react';
import DropdownMenu, { DropdownItemGroupRadio, DropdownItemRadio } from '@atlaskit/dropdown-menu';
import './done-by-filter.scss';

interface Props {
  label: string;
  values: string[];
  selected: string;
  isLoading?: boolean;
  // eslint-disable-next-line no-unused-vars
  onSelected: (selected: string) => void;
}

const DoneByFilter = ({ label, values, onSelected, selected, isLoading = false }: Props) => {
  return (
    <div className="done-by-container" data-testid="done-by">
      <DropdownMenu
        trigger={label}
        triggerType="button"
        position="bottom left"
        testId="done-by-menu"
        triggerButtonProps={{
          className: 'trigger-button',
        }}
        isLoading={isLoading}
      >
        <DropdownItemGroupRadio id="actions" data-testid="done-by-groupdropdown">
          {values.map((doneBy, index) => {
            return (
              <DropdownItemRadio
                key={index}
                id={`id-${doneBy}`}
                onClick={() => {
                  onSelected(doneBy);
                }}
                isSelected={doneBy === selected}
                data-testid={doneBy}
              >
                {doneBy}
              </DropdownItemRadio>
            );
          })}
        </DropdownItemGroupRadio>
      </DropdownMenu>
    </div>
  );
};

export default DoneByFilter;
